"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createWaitingListData = createWaitingListData;
const access_1 = require("../../../forms/ktx/basic-registration-data/waiting-list-data/access");
const renalReplacementTherapy_1 = require("../../../forms/ktx/basic-registration-data/waiting-list-data/renalReplacementTherapy");
const shared_1 = require("../../shared");
const createKidneyDiseaseEthiology_1 = require("./createKidneyDiseaseEthiology");
const queries_1 = require("../queries");
const graftloss_1 = require("../../../forms/ktx/basic-registration-data/waiting-list-data/graftloss");
const events_1 = require("../../../events");
const messages = {
    renal: {
        id: "ktx.dashboard.waiting_list_data",
        defaultMessage: "Várólista adatok"
    },
    renalReplacementTherapy: {
        id: "ktx.dashboard.waiting_list_data.renal_replacement_therapy",
        defaultMessage: "Jelenlegi vesepótló kezelés"
    },
    access: {
        id: "ktx.dashboard.waiting_list_data.access",
        defaultMessage: "Jelenlegi vérnyerés, vagy egyéb dialízis katéter"
    },
    graftloss: {
        id: "ktx.dashboard.waiting_list_data.graftloss",
        defaultMessage: "Graftvesztés"
    }
};
function createWaitingListData(intl, options) {
    const { events } = options;
    const kidneyDiseaseEthiology = (0, createKidneyDiseaseEthiology_1.createKidneyDiseaseEthiology)(intl, options);
    const renalReplacementTherapy = createLast(intl, {
        events,
        label: messages.renalReplacementTherapy,
        query: queries_1.waitingListQueries.renalReplacementTherapy,
        messages: renalReplacementTherapy_1.renalReplacementTherapyTypeMessages
    });
    const access = createLast(intl, {
        events,
        label: messages.access,
        query: queries_1.waitingListQueries.access,
        messages: access_1.accessTypeMessages
    });
    const gm = { ...graftloss_1.causeOfGraftlossMessages, ...graftloss_1.hasGraftlossMessages };
    const graftloss = createLast(intl, {
        events,
        label: messages.graftloss,
        query: queries_1.waitingListQueries.graftloss,
        messages: gm
    });
    const content = (0, shared_1.createSectionContent)([
        kidneyDiseaseEthiology,
        renalReplacementTherapy,
        access,
        graftloss
    ]);
    return (0, shared_1.createSection)(intl, { label: messages.renal, content });
}
function createLast({ formatMessage, formatMessageMap }, { events, label, query, messages }) {
    const event = (0, events_1.findLastEventByQuery)(events, query);
    if (event === undefined) {
        return undefined;
    }
    let v;
    const inc = Object.keys(messages).includes(event.value);
    if (!inc) {
        v = event.value;
    }
    else {
        v = formatMessageMap(messages, event.value);
    }
    return {
        type: "record",
        label: formatMessage(label),
        attachments: (0, events_1.mapEventsToAttachments)(event),
        value: v,
        timestamp: event.timestamp,
        origin: event.origin
    };
}
